import { GlobalState } from "../reducers";

export const getAuthState = (state: GlobalState) => state.auth;
export const selectAdminStatus = (state: GlobalState) => {
    if (state?.ui.profile.isAdminToggled) return false;
    return state?.profile?.profile?.status === "employee";
};
